import { Authority } from '@/shared/security/authority';

const Buchhaltung = () => import('@/buchhaltung/buchhaltung.vue');
const Statistik = () => import('@/buchhaltung/statistic.vue');

export default [
  {
    path: '/buchhaltung',
    name: 'Buchhaltung',
    component: Buchhaltung,
    meta: { authorities: [Authority.BUCHHALTUNG] },
  },
  {
    path: '/statistic',
    name: 'Statistik',
    component: Statistik,
    meta: { authorities: [Authority.BUCHHALTUNG] },
  },
];
